export default __webpack_public_path__ + "static/martina-plantijn-web-bold-e611bb9eb1ad53b4306a0dccc6f3d509.woff2";